export const GlobalVars = {
    iconSize: {
        xxs: 14,
        xs: 18,
        sm: 22,
        md: 25,
        lg: 28,
        xl: 30,
        xxl: 40,
    },
    styles: {
        modal: {
            overlay: {zIndex: 100, backdropFilter: "blur(4px)"},
        },
        lightStepper: {
            activeBgColor: '#58979a',
            activeTextColor: '#ffffff',
            inactiveBgColor: '#ffffff',
            inactiveTextColor: '#babbbf',
            completedBgColor: '#4f5052',
            completedTextColor: '#ffffff',
            labelFontSize: "1.2rem",
            circleFontSize: "1.4rem",
            size: '2.5em'
        },
        lightStepperLine: {
            disabledColor: "#babbbf",
            activeColor: "#58979b",
            completedColor: "#2e2e2e",
            size: 2,
            stepSize: "2.6em",
            style: "solid",
        },
        darkStepper: {
            activeBgColor: '#000000',
            activeTextColor: '#FFFFFF',
            inactiveBgColor: '#FFFFFF',
            inactiveTextColor: '#09BC8A',
            completedBgColor: '#FFFFFF',
            completedTextColor: '#09BC8A',
            size: '2.5em'
        },
        darkStepperLine: {
            disabledColor: "#CCD7C1",
            activeColor: "#519872",
            completedColor: "#3B5249",
            size: "1",
            stepSize: "2em",
            style: "solid",
        },
    },
    functions: {
        uniqueArray: (a) => [...new Set(a.map(o => JSON.stringify(o)))].map(s => JSON.parse(s)),
    }
}

export const apiURL = process.env.REACT_APP_API_URL;